import { render, staticRenderFns } from "./VBlockContent.vue?vue&type=template&id=f22bb226&scoped=true"
import script from "./VBlockContent.vue?vue&type=script&lang=js"
export * from "./VBlockContent.vue?vue&type=script&lang=js"
import style0 from "./VBlockContent.vue?vue&type=style&index=0&id=f22bb226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22bb226",
  null
  
)

export default component.exports